import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/day-theme.css";
import App from "@/App";
import { initTheme } from "@/utils/theme";

// Apply the persisted Day/Night theme BEFORE React renders so daytime
// users don't flash dark on first paint.
initTheme();

// Register service worker for PWA. Includes auto-update logic so a fresh
// build is picked up the next time the user opens the app, plus a one-shot
// auto-reload when a new SW takes control so users don't have to manually
// refresh after a deploy.
if ('serviceWorker' in navigator) {
  // Guard against the controllerchange + reload loop.
  let swRefreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (swRefreshing) return;
    swRefreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // When a new SW takes over, prompt-skip so it activates immediately.
      reg.addEventListener('updatefound', () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener('statechange', () => {
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            installing.postMessage({ type: 'SW_SKIP_WAITING' });
          }
        });
      });
    }).catch(() => {});
    // Periodically clean stale API cache entries (>24h) so storage stays bounded.
    setTimeout(() => {
      navigator.serviceWorker.controller?.postMessage({ type: 'SW_CLEANUP_STALE_API' });
    }, 5000);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
